<div class="row">
  <div class="col-lg-12 col-md-12 mg-a">
    <div class="row hdrBar">
      <div class="col-lg-12 col-md-12 mg-a">
        <h1>Add Vehicle Distance/working hours</h1>
      </div>
    </div>
  </div>
</div>
<div class="main">
  @if (showLdr) {
  <ds-loading></ds-loading>
  }
  <div class="fltrsCrd" style="margin-bottom: 24px">
    <div
      class="filters-flex-row beautify-filters"
      style="
        display: flex;
        gap: 20px;
        align-items: flex-end;
        width: 100%;
        max-width: 100vw;
        padding: 12px 0;
        background: #f8fafd;
        border-radius: 8px;
      "
    >
      @if (tntLst.length>1) {
      <div class="customWidth beautify-field" style="flex: 1; min-width: 180px">
        <div class="drpLbl">Select ULB</div>
        <nz-select
          class="slctBx"
          nzShowSearch
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          <!-- <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option> -->
          @for (t of tntLst; track t) {
          <nz-option
            [nzValue]="t.tnt_id"
            [nzLabel]="t.tnt_dsply_nm"
          ></nz-option>
          }
        </nz-select>
      </div>
      } @if (tntLst.length==1) {
      <div class="customWidth beautify-field" style="flex: 1; min-width: 180px">
        <div class="drpLbl">ULB</div>
        <div class="slctBx disbledtxt">{{ tntLst[0].tnt_nm }}</div>
      </div>
      }
      <div class="customWidth beautify-field" style="flex: 1; min-width: 180px">
        <p class="slctlbl">Vehicle</p>
        <nz-select
          class="slctBx"
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Please select Vehicle"
          [(ngModel)]="selectedVehicle"
          (ngModelChange)="onVehicleChange($event)"
        >
          @for (v of vhcleslst; track v) {
          <nz-option [nzLabel]="v.asrt_nm" [nzValue]="v.asrt_id"></nz-option>
          }
        </nz-select>
      </div>
      <div class="customWidth beautify-field" style="flex: 1; min-width: 600px">
        <p class="slctlbl">Date Range</p>
        <nz-range-picker
          class="slctBx beautify-date-picker"
          [(ngModel)]="dateRange"
          [nzFormat]="'dd/MM/yyyy'"
          [nzDisabledDate]="disabledDate"
          [ngModelOptions]="{ standalone: true }"
        ></nz-range-picker>
      </div>
      <!-- <div class="customWidth beautify-field" style="flex:1; min-width:600px;" *ngIf="blngPrmtrId==2">
      <p class="slctlbl">Date</p>
      <nz-date-picker class="slctBx beautify-date-picker" [(ngModel)]="dte" [nzFormat]="'dd/MM/yyyy'"
      [nzDisabledDate]="disabledDate" [ngModelOptions]="{standalone: true}"></nz-date-picker>
    </div> -->
      <div
        class="customWidth fltrSbmitBtn beautify-btn"
        style="flex: 1; min-width: 140px; display: flex; align-items: end"
      >
        <button
          nz-button
          nzType="primary"
          class="beautify-get-btn"
          (click)="onGetData()"
        >
          Get Data
        </button>
      </div>
    </div>
  </div>
  @if (showGrid) {
  <div>
    <div class="row bg-wp">
      <div
        class="ds-card grid tbl"
        style="
          padding: 24px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        "
      >
        @if (blngPrmtrId==1) {
        <div>
          <h1 style="font-size: 20px; margin-top: 16px; margin-bottom: 24px">
            Vehicle Distance Data
          </h1>
          <app-data-grid
            [allowedPageSizes]="[10, 20, 30, 50]"
            id="gridContainer"
            style="width: 100%"
            [dataSource]="gridData"
            [legacyColumns]="columnDefs"
            [searchPanel]="true"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            exportFileName="Alerts Data"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
            (cellClick)="onCellClick($event)"
          >
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              [width]="150"
              caption="Add Distance"
              cellTemplate="AddDistance"
            ></app-grid-column>
            <ng-template appGridCell="AddDistance" let-data="cell"
              ><div>
                @if (data.data.dt_in == 1) {
                <span>{{ data.data.addedDst }}</span>
                } @else {
                <ng-container>
                  <input
                    nz-input
                    [(ngModel)]="data.data.addedDst"
                    placeholder="Enter Distance"
                    style="width: 100%"
                  />
                </ng-container>
                }
              </div></ng-template
            >
          </app-data-grid>
          @if (showSubmitButton && allRowsHaveDistance) {
          <div
            style="display: flex; justify-content: flex-end; margin-top: 32px"
          >
            <button
              nz-button
              nzType="primary"
              class="final-submit-btn"
              [nzLoading]="isSaving"
              [disabled]="isSaving || !perms.canWrite()"
              [title]="
                !perms.canWrite() ? 'You do not have permission to save' : ''
              "
              (click)="onSubmitDistances()"
            >
              {{ isSaving ? "Saving..." : "Submit" }}
            </button>
          </div>
          }
        </div>
        } @if (blngPrmtrId==2) {
        <div>
          <h1 style="font-size: 20px; margin-top: 16px; margin-bottom: 24px">
            Vehicle Working Hours Data
          </h1>
          <app-data-grid
            [allowedPageSizes]="[10, 20, 30, 50]"
            id="gridContainer"
            style="width: 100%"
            [dataSource]="wrkngData"
            [legacyColumns]="wrkngColumnDefs"
            [searchPanel]="true"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            exportFileName="Working Hours Data"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
            (cellClick)="onWrkngCellClick($event)"
          >
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              [width]="180"
              caption="Start Time"
              cellTemplate="StartTime"
            ></app-grid-column>
            <ng-template appGridCell="StartTime" let-data="cell"
              ><div>
                @if (data.data.showTimePickers) {
                <nz-time-picker
                  [(ngModel)]="data.data.startTime"
                  [nzFormat]="'HH:mm:ss'"
                  style="width: 100%"
                  (ngModelChange)="onNewRowTimeChange(data.data)"
                  nzPlaceHolder="Start Time"
                >
                </nz-time-picker>
                } @else {
                <span style="color: #999; font-style: italic"
                  >Has existing data</span
                >
                }
              </div></ng-template
            >
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              [width]="280"
              caption="Add Time"
              cellTemplate="AddTime"
            ></app-grid-column>
            <ng-template appGridCell="AddTime" let-data="cell"
              ><div>
                @if (data.data.showTimePickers) {
                <div style="display: flex; gap: 8px; align-items: center">
                  <input
                    nz-input
                    [(ngModel)]="data.data.addedHrs"
                    placeholder="Hours"
                    style="width: 70px"
                    type="number"
                    step="1"
                    min="0"
                    (ngModelChange)="onNewRowTimeChange(data.data)"
                  />
                  <span style="color: #666">:</span>
                  <input
                    nz-input
                    [(ngModel)]="data.data.addedMins"
                    placeholder="Mins"
                    style="width: 70px"
                    type="number"
                    step="1"
                    min="0"
                    max="59"
                    (ngModelChange)="onNewRowTimeChange(data.data)"
                  />
                </div>
                } @else {
                <div style="display: flex; gap: 8px; align-items: center">
                  <nz-select
                    [(ngModel)]="data.data.timeSign"
                    placeholder="Sign"
                    style="width: 60px"
                    (ngModelChange)="onAddTimeChange(data.data)"
                  >
                    <nz-option nzValue="+" nzLabel="+"></nz-option>
                    <nz-option nzValue="-" nzLabel="-"></nz-option>
                  </nz-select>
                  <input
                    nz-input
                    [(ngModel)]="data.data.addedHrs"
                    placeholder="Hours"
                    style="width: 70px"
                    type="number"
                    step="1"
                    min="0"
                    (ngModelChange)="onAddTimeChange(data.data)"
                  />
                  <span style="color: #666">:</span>
                  <input
                    nz-input
                    [(ngModel)]="data.data.addedMins"
                    placeholder="Mins"
                    style="width: 70px"
                    type="number"
                    step="1"
                    min="0"
                    max="59"
                    (ngModelChange)="onAddTimeChange(data.data)"
                  />
                </div>
                }
              </div></ng-template
            >
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              [width]="240"
              caption="Future Working Hours"
              cellTemplate="FutureHrs"
            ></app-grid-column>
            <ng-template appGridCell="FutureHrs" let-data="cell"
              ><div>
                @if (data.data.futureHrsDisplay) {
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 2px;
                  "
                >
                  <span
                    style="font-size: 15px; font-weight: 700; color: #1890ff"
                  >
                    {{ data.data.futureHrsDisplay }}
                  </span>
                  @if (data.data.showTimePickers && data.data.startTimeDisplay
                  && data.data.endTimeDisplay) {
                  <span style="font-size: 11px; color: #52c41a">
                    {{ data.data.startTimeDisplay }} →
                    {{ data.data.endTimeDisplay }}
                  </span>
                  } @if (data.data.hasExistingData) {
                  <span style="font-size: 11px; color: #999">
                    ({{ data.data.addedHrsDisplay }})
                  </span>
                  }
                </div>
                } @if (!data.data.futureHrsDisplay) {
                <span style="color: #ccc">—</span>
                }
              </div></ng-template
            >
          </app-data-grid>
          @if (showSubmitWrkngButton && !allRowsHaveWorkingHours) {
          <div
            style="
              margin-top: 16px;
              padding: 12px;
              background: #fff7e6;
              border: 1px solid #ffd591;
              border-radius: 4px;
              color: #d46b08;
            "
          >
            <strong>⚠ Please complete all rows before submitting:</strong>
            <ul style="margin: 8px 0 0 20px; padding: 0">
              <li>
                For <strong>new entries</strong>: Select Start Time AND enter
                Hours or Minutes to add
              </li>
              <li>
                For <strong>existing data</strong>: Select +/- sign AND enter
                Hours or Minutes
              </li>
            </ul>
          </div>
          } @if (showSubmitWrkngButton && allRowsHaveWorkingHours) {
          <div
            style="display: flex; justify-content: flex-end; margin-top: 32px"
          >
            <button
              nz-button
              nzType="primary"
              class="final-submit-btn"
              [nzLoading]="isSaving"
              [disabled]="isSaving || !perms.canWrite()"
              [title]="
                !perms.canWrite() ? 'You do not have permission to save' : ''
              "
              (click)="onSubmitWorkingHours()"
            >
              {{ isSaving ? "Saving..." : "Submit" }}
            </button>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
